export default __webpack_public_path__ + "static/media/registrocerrado_1coloquio3_movil.a5f08610.jpg";